export default function verificarIdsValidos(array: IItem[]): boolean {
    return !array.some(item => item.id === null || Number.isNaN(item.id));
}

interface IItem {
    id: number | null;
    nome: string;
}
